import styles from './EducationCertificationsHeader.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCertificate } from '@fortawesome/free-solid-svg-icons';

function EducationCertificationsHeader() {
    return (
        <div className={`${styles['education-certifications']}`}>
            <div className={`${styles['education-certifications-intro']}`}>
                <h1 className={`${styles['education-certifications-header']}`}>
                    <span>
                        <FontAwesomeIcon
                            icon={faCertificate}
                            className={`${styles['education-certifications-header-icon']}`}
                        />
                    </span>
                    Certifications
                </h1>
                <p className={`${styles['education-certifications-description']}`}>
                    I firmly believe that the certification process serves as an effective method
                    for verifying and validating both knowledge and practical experience within a
                    specific functional area.
                </p>
            </div>
        </div>
    );
}

export default EducationCertificationsHeader;
